import "../css"

import { visit } from "@hotwired/turbo"
import { DirectUpload } from "@rails/activestorage"
import Tooltip from "bootstrap/js/dist/tooltip"
import heic2any from "heic2any"
import Cropper from "cropperjs"
import "cropperjs/dist/cropper.css"

const insertPhotoInput = (value) => {
  const form = document.querySelector("form[id*=listing]")
  form.insertAdjacentHTML("beforeend", `<input type="hidden" name="listing[photo]" value="${value}">`)
}

const initCropper = (file) => {
  const img = document.createElement("img")
  img.src = URL.createObjectURL(file)
  document.querySelector("#preview").replaceChildren(img)

  cropper = new Cropper(img, {
    viewMode: 1,
    aspectRatio: 1
  })
}

const setCharCount = (count) => {
  if (!count) {
    const bio = document.querySelector("#listing_bio")
    if (!bio) return
    count = bio.value.length
  }
  document.querySelector("#bio-count").innerText = `${count} / 1000`
}

let cropper

addEventListener("click", ({ target }) => {
  const card = target.closest(".card[data-url]")
  if (card) {
    visit(card.dataset.url)
  }

  if (target.closest("#clear-photo")) {
    cropper?.destroy()
    cropper = null

    document.querySelector("#preview").innerHTML = '<i class="fas fa-user text-body-tertiary"></i>'
    document.querySelector('input[name="photo"]').value = null
    document.querySelector('input[name="listing[photo]"]')?.remove()
    insertPhotoInput("")
  }
})

addEventListener("turbo:load", () => {
  setCharCount()

  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => new Tooltip(el))
})

addEventListener("change", ({ target }) => {
  if (target.matches("#photo")) {
    const file = target.files[0]

    if (file.type === "image/heif" || file.type === "image/heic") {
      heic2any({ blob: file, toType: "image/jpeg" })
        .then(converted => initCropper(converted))
        .catch(() => initCropper(file))
    } else {
      initCropper(file)
    }
  }
})

addEventListener("turbo:submit-start", ({ target, detail }) => {
  const input = target.querySelector('input[type="file"][data-upload-url]')
  if (!input || input.files.length == 0 || input.disabled) return

  const submit = target.querySelector('[type="submit"]')
  const oldSubmitContent = submit.innerHTML
  submit.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'

  detail.formSubmission.stop()
  const url = input.dataset.uploadUrl
  const origFile = input.files[0]

  cropper.getCroppedCanvas().toBlob(blob => {
    let upload

    if (blob) {
      const file = new File([blob], origFile.name)
      upload = new DirectUpload(file, url)
    } else {
      upload = new DirectUpload(origFile, url)
    }

    upload.create((error, result) => {
      if (error) {
        document.querySelector("#photo-failed").classList.remove("d-none")
        submit.innerHTML = oldSubmitContent
      } else {
        insertPhotoInput(result.signed_id)
        input.disabled = true
        submit.click()
      }
    })
  }, origFile.type)
})

addEventListener("keyup", ({ target }) => {
  if (target.matches("#listing_bio")) {
    setCharCount(target.value.length)
  }
})

const ageCheckboxSelector = 'input[name="ages"][type="checkbox"]'
const allAgesSelector = `${ageCheckboxSelector}:not([value])`
const ageOptionsSelector = `${ageCheckboxSelector}[value]`

const updateFilters = () => {
  document.querySelectorAll("a[data-param]").forEach(a => {
    const { param, value } = a.dataset
    const url = new URL(location.href)
    url.searchParams.delete("page")
    const current = url.searchParams.get(param)

    if (value == current) {
      a.classList.add("d-none")

      const button = a.closest(".dropdown")?.querySelector("button")
      if (button) {
        button.innerText = value ? a.innerText : button.dataset.default
      }
    } else {
      a.classList.remove("d-none")
    }

    if (value) {
      url.searchParams.set(param, value)
    } else {
      url.searchParams.delete(param)
    }

    a.href = url.toString()
  })

  const search = document.querySelector("#search-form")
  if (search) {
    search.querySelectorAll('input[type="hidden"]').forEach(el => el.remove())

    const url = new URL(location.href)
    url.searchParams.delete("page")
    url.searchParams.delete("search")
    url.searchParams.delete("commit")
    url.searchParams.forEach((v, k) => {
      search.insertAdjacentHTML("beforeend", `<input type="hidden" name="${k}" value="${v}">`)
    })

    document.querySelectorAll(".directory-link").forEach(el => el.href = url.toString())

    const allAges = document.querySelector(allAgesSelector)
    const ageOptions = document.querySelectorAll(ageOptionsSelector)
    const ageValues = [...ageOptions].map(el => el.value)
    const ages = url.searchParams.get("ages")?.split(",").filter(a => ageValues.includes(a)) || []

    if (ages.length > 0 && ages.length < ageOptions.length) {
      allAges.checked = false
      ages.forEach(age => {
        const el = document.querySelector(`${ageCheckboxSelector}[value="${age}"]`)
        if (el) el.checked = true
      })
    } else {
      allAges.checked = true
      ageOptions.forEach(el => el.checked = false)
    }
  }
}

addEventListener("turbo:load", updateFilters)
addEventListener("turbo:frame-load", updateFilters)

addEventListener("change", ({ target }) => {
  if (target.matches(ageCheckboxSelector)) {
    const allAges = document.querySelector(allAgesSelector)
    const ageOptions = document.querySelectorAll(ageOptionsSelector)

    if (!target.getAttribute("value") && target.checked) {
      ageOptions.forEach(el => el.checked = false)
    } else {
      allAges.checked = false
    }

    let ages = [...document.querySelectorAll(`${ageOptionsSelector}:checked`)].map(el => el.value)

    if (ages.length == 0) {
      allAges.checked = true
    } else if (ages.length == ageOptions.length) {
      ages = []
      allAges.checked = true
      ageOptions.forEach(el => el.checked = false)
    }

    const url = new URL(location.href)
    url.searchParams.delete("page")

    if (ages.length == 0) {
      url.searchParams.delete("ages")
    } else {
      url.searchParams.set("ages", ages.join(","))
    }

    visit(url, { frame: "listings" })
  }
})
